import { instance } from "api/apiBase";
import type {
  MarkActivityReadResponse,
  MarkViewedResponse,
  UnitsFilterOptions,
  UnitsFilterOptionsParams
} from "api/units/types";

export const unitsApi = {
  getFilterOptions: (params: UnitsFilterOptionsParams) =>
    instance
      .get<UnitsFilterOptions>("/portal/v1/units/filter_options", { params })
      .then((res) => res.data),

  markViewed: (unitId: number) =>
    instance
      .post<MarkViewedResponse>(`/portal/v1/units/${unitId}/viewed`)
      .then((res) => res.data),

  markActivityRead: (unitId: number, activityLogId: number) =>
    instance
      .post<MarkActivityReadResponse>(
        `/portal/v1/units/${unitId}/activity_read`,
        {
          activity_log_id: activityLogId
        }
      )
      .then((res) => res.data)
};
